import { render } from "./ic7_batch.vue?vue&type=template&id=524c2834&scoped=true"
import script from "./ic7_batch.vue?vue&type=script&lang=js"
export * from "./ic7_batch.vue?vue&type=script&lang=js"

import "./ic7_batch.vue?vue&type=style&index=0&id=524c2834&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524c2834"]])

export default __exports__